export const statesArray = [
    {
        id: 1,
        slug: 'ak',
        name: 'Alaska',
        abbreviation: 'AK',
    },
    {
        id: 2,
        slug: 'al',
        name: 'Alabama',
        abbreviation: 'AL',
    },
    {
        id: 3,
        slug: 'ar',
        name: 'Arkansas',
        abbreviation: 'AR',
    },
    {
        id: 4,
        slug: 'az',
        name: 'Arizona',
        abbreviation: 'AZ',
    },

    {
        id: 5,
        slug: 'ca',
        name: 'California',
        abbreviation: 'CA',
    },
    {
        id: 6,
        slug: 'co',
        name: 'Colorado',
        abbreviation: 'CO',
    },
    {
        id: 7,
        slug: 'ct',
        name: 'Connecticut',
        abbreviation: 'CT',
    },
    {
        id: 9,
        slug: 'de',
        name: 'Delaware',
        abbreviation: 'DE',
    },
    {
        id: 8,
        slug: 'dc',
        name: 'District of Columbia',
        abbreviation: 'DC',
    },
    {
        id: 10,
        slug: 'fl',
        name: 'Florida',
        abbreviation: 'FL',
    },
    {
        id: 11,
        slug: 'ga',
        name: 'Georgia',
        abbreviation: 'GA',
    },
    {
        id: 12,
        slug: 'hi',
        name: 'Hawaii',
        abbreviation: 'HI',
    },
    {
        id: 13,
        slug: 'ia',
        name: 'Iowa',
        abbreviation: 'IA',
    },
    {
        id: 14,
        slug: 'id',
        name: 'Idaho',
        abbreviation: 'ID',
    },
    {
        id: 15,
        slug: 'il',
        name: 'Illinois',
        abbreviation: 'IL',
    },
    {
        id: 16,
        slug: 'in',
        name: 'Indiana',
        abbreviation: 'IN',
    },
    {
        id: 17,
        slug: 'ks',
        name: 'Kansas',
        abbreviation: 'KS',
    },
    {
        id: 18,
        slug: 'ky',
        name: 'Kentucky',
        abbreviation: 'KY',
    },
    {
        id: 19,
        slug: 'la',
        name: 'Louisiana',
        abbreviation: 'LA',
    },
    {
        id: 20,
        slug: 'ma',
        name: 'Massachusetts',
        abbreviation: 'MA',
    },
    {
        id: 21,
        slug: 'md',
        name: 'Maryland',
        abbreviation: 'MD',
    },
    {
        id: 22,
        slug: 'me',
        name: 'Maine',
        abbreviation: 'ME',
    },

    {
        id: 23,
        slug: 'mi',
        name: 'Michigan',
        abbreviation: 'MI',
    },
    {
        id: 24,
        slug: 'mn',
        name: 'Minnesota',
        abbreviation: 'MN',
    },
    {
        id: 25,
        slug: 'mo',
        name: 'Missouri',
        abbreviation: 'MO',
    },
    {
        id: 26,
        slug: 'ms',
        name: 'Mississippi',
        abbreviation: 'MS',
    },

    {
        id: 27,
        slug: 'mt',
        name: 'Montana',
        abbreviation: 'MT',
    },
    {
        id: 28,
        slug: 'nc',
        name: 'North Carolina',
        abbreviation: 'NC',
    },
    {
        id: 29,
        slug: 'nd',
        name: 'North Dakota',
        abbreviation: 'ND',
    },
    {
        id: 30,
        slug: 'ne',
        name: 'Nebraska',
        abbreviation: 'NE',
    },
    {
        id: 31,
        slug: 'nh',
        name: 'New Hampshire',
        abbreviation: 'NH',
    },
    {
        id: 32,
        slug: 'nj',
        name: 'New Jersey',
        abbreviation: 'NJ',
    },
    {
        id: 33,
        slug: 'nm',
        name: 'New Mexico',
        abbreviation: 'NM',
    },
    {
        id: 34,
        slug: 'nv',
        name: 'Nevada',
        abbreviation: 'NV',
    },

    {
        id: 35,
        slug: 'ny',
        name: 'New York',
        abbreviation: 'NY',
    },

    {
        id: 36,
        slug: 'oh',
        name: 'Ohio',
        abbreviation: 'OH',
    },
    {
        id: 37,
        slug: 'ok',
        name: 'Oklahoma',
        abbreviation: 'OK',
    },
    {
        id: 38,
        slug: 'or',
        name: 'Oregon',
        abbreviation: 'OR',
    },
    {
        id: 39,
        slug: 'pa',
        name: 'Pennsylvania',
        abbreviation: 'PA',
    },
    {
        id: 40,
        slug: 'ri',
        name: 'Rhode Island',
        abbreviation: 'RI',
    },
    {
        id: 41,
        slug: 'sc',
        name: 'South Carolina',
        abbreviation: 'SC',
    },
    {
        id: 42,
        slug: 'sd',
        name: 'South Dakota',
        abbreviation: 'SD',
    },
    {
        id: 43,
        slug: 'tn',
        name: 'Tennessee',
        abbreviation: 'TN',
    },
    {
        id: 44,
        slug: 'tx',
        name: 'Texas',
        abbreviation: 'TX',
    },
    {
        id: 45,
        slug: 'ut',
        name: 'Utah',
        abbreviation: 'UT',
    },
    {
        id: 46,
        slug: 'va',
        name: 'Virginia',
        abbreviation: 'VA',
    },
    {
        id: 47,
        slug: 'vt',
        name: 'Vermont',
        abbreviation: 'VT',
    },

    {
        id: 48,
        slug: 'wa',
        name: 'Washington',
        abbreviation: 'WA',
    },
    {
        id: 49,
        slug: 'wi',
        name: 'Wisconsin',
        abbreviation: 'WI',
    },
    {
        id: 50,
        slug: 'wv',
        name: 'West Virginia',
        abbreviation: 'WV',
    },
    {
        id: 51,
        slug: 'wy',
        name: 'Wyoming',
        abbreviation: 'WY',
    },
];

export const statesArrayNames = statesArray.map((state) => state.name);
